import $ from 'jquery';
import _ from "underscore";
import {setElementsFromScope, swapClasses} from "../../utilities/selectorHelpers";
import {isPresent} from "../../utilities/general";
import moment from "moment";
import render from "../../utilities/render";
require("./resourceProgress.less");
import assign from 'object-assign';
const mainTemplate = require("./html/resourceProgressContainer.html");
const cardTemplate = require("./html/resourceProgressCard.html");

//el refers to outer most container
export default function resourceProgress(el, options) {
  el = $(el);

  if (el.length) {
    let resourceProgressObject = el.data("resource-progress");
    if (resourceProgressObject) {
      resourceProgressObject.setOptions(options);
    }
    else {
      resourceProgressObject = resourceProgressFactory(el, options);
      resourceProgressObject.init();
      el.data("resource-progress", resourceProgressObject);
    }
    return resourceProgressObject;
  }
  else {
    throw new Error({name: "No Element Error", message: "Element must be a jquery element or dom element"});
  }
}


const themesMap = {
  info: {
    backgroundColor: "q-bg-c-blue"
  },
  success: {
    backgroundColor: "q-bg-c-lime-green"
  },
  darkGrey: {
    backgroundColor: "q-bg-c-more-light-grey"
  },
  lightGrey: {
    backgroundColor: "q-bg-c-lighter-grey"
  },
  pending: {
    backgroundColor: "q-bg-c-red"
  }
};

const elsMap = {
  resourceTitle: ".resource-title",
  resourceTimestamp: ".resource-timestamp",
  resourceIcon: ".resource-icon",
  resourceBgColor: ".resource-background-color"
};

const iconsMap = {
  backArrow: {
    iconClass: "fa-reply",
    color: "white"
  },
  calendar: {
    iconClass: "fa-calendar",
    color: "white"
  },
  cancel: {
    iconClass: "fa-close",
    color: "white"
  },
  dollar: {
    iconClass: "fa-usd",
    color: "white"
  },
  print: {
    iconClass: "fa-print",
    color: "white"
  },
  truck: {
    iconClass: "fa-truck",
    color: "white"
  },
  hazardTriangle: {
    iconClass: "fa-exclamation-triangle",
    color: "white"
  }
};


function resourceProgressFactory(el, options) {
  const self = {};
  const statuses = options.data.statuses;
  const lifecycleFinished = options.data.endOfLifecycle;
  const htmlWrapper = el;
  const outerMostEl = $(mainTemplate);
  const outerEl = $(outerMostEl).find('.resource-progress-container');
  const mainEl = outerEl.find(".resource-progress-inner");

  // NOTE: optional function to let user change card options during runtime if needed
  // self.setCardDataById = function(id, statusUpdate){
  //   const originalStatus = _(statuses).find((item)=>{
  //     return item.id == id;
  //   })
  //   const finalStatus = _.merge(originalStatus, statusUpdate)
  //   const newCard = buildCard(finalStatus)
  //   const oldCard = mainEl.find(`#${originalStatus.id}`)
  //   newCard.after(oldCard);
  //   oldCard.remove();
  // }

  //========================PRIVATE FUNCTIONS======================
  /*data will need following vars: title, timestamp, way to indicate that it's
   last in array?, some sort of status constant that will never change,
   which will determine icon and icon color (if cancelled)*/

  function appendOuterEl() {
    htmlWrapper.append(outerMostEl);

    appendCardEls();
  }

  function appendCardEls() {
    const cardElArray = _(statuses).map(buildCard);

    mainEl.append(cardElArray);

    scrollContainerToRight();

    _(mainEl.find(elsMap.resourceTitle).toArray()).map(truncateLongTitles);
  }

  function scrollContainerToRight(){
    var mainElWidth = mainEl.width();
    outerEl.scrollLeft(mainElWidth);
  };

  function buildCard(dataObj) {
    const cardEl = $(cardTemplate);

    // NOTE: optional prop to let user change card options during runtime if needed
    // cardEl.prop('id', dataObj.id);

    let icon = cardEl.find(elsMap.resourceIcon);
    let iconBackground = cardEl.find(elsMap.resourceBgColor);
    let title = cardEl.find(elsMap.resourceTitle);
    let timeStamp = cardEl.find(elsMap.resourceTimestamp);
    // FOR EXAMPLE: dataObj.icon = "truck";
    const {iconClass, color} = iconsMap[dataObj.icon];

    // FOR EXAMPLE: iconsMap.truck, or iconsMap.dollar
    icon.addClass(iconClass);
    icon.css({color: color});

    title.text(dataObj.title);
    timeStamp.text(dataObj.time);

    const cardColor =  getCardColor(dataObj);
    iconBackground.addClass(cardColor.backgroundColor);

    return cardEl;
  }

  function getCardColor(dataObj){
    const hasThemeKey = _(dataObj).has('theme');
    if(hasThemeKey) {
      return getCardColorFromTheme(dataObj)
    } else {
      return getCardColorForActiveStatus(dataObj);
    }
  }

  function getCardColorFromTheme(dataObj){
    // if the theme parameter is empty, or if string doesn't match themesMap, this defaults to getting color based on active status
    const cardColor = themesMap[dataObj.theme] || getCardColorForActiveStatus(dataObj);
    return cardColor;
  }

  function getCardColorForActiveStatus(dataObj){
    if (dataObj.active === true) {
      return {
        backgroundColor: "q-bg-c-purple"
      };
    } else {
      return {
        backgroundColor: "q-bg-c-lighter-grey"
      };
    }
  };

  function truncateLongTitles(title) {
    $(title).dotdotdot({
      wrap: "letter"
    });
  };

//===================PUBLIC FUNCTIONS===================
//options users can configure = for future development if needed
  self.setOptions = function (options) {
    //code code set configurable options here
  };

  self.init = function () {
    appendOuterEl();
  };

  return self;
}



// WEBPACK FOOTER //
// ./src/components/resourceProgress/resourceProgress.js